import React from "react";
import "./AlbumCard.css";

// The props now match the keys in portfolioData.json
function AlbumCard({ name, previewImage, link, delay }) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="album-card"
      style={{ animationDelay: delay }}
    >
      <img src={previewImage} alt={name} className="album-card-image" />
      <div className="album-card-info">
        <h3>{name}</h3>
      </div>
    </a>
  );
}

export default AlbumCard;
